import ProductMicrodata from './ProductMicrodata';
import ProductListMicrodata from './ProductListMicrodata';
import HomeMicrodata from './HomeMicrodata';

export { ProductMicrodata, ProductListMicrodata, HomeMicrodata };
